export default "skymp5-front/6c60d5c33811c5b37b588a80f9de9a26.jpg";